import { runInAction } from "mobx";
import { dashboardService } from "../services/dashboard.service";
import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardConsolidatedOrgDetailStore } from "../stores/consolidated-org-detail.store";
import { buildDashboardScopePayload } from "../utils/dashboard-request-scope";
import { resolveSelectedReportingPeriod } from "../utils/reporting-years";

export const loadConsolidatedOrgDetailForPanel = async (key) => {
  const store = dashboardConsolidatedOrgDetailStore;
  const panel = store.getPanel(key);
  if (!panel || !panel.pivot) return;

  const { years, frameworks, categories } = dashboardFiltersStore.filters;
  const { orgId } = panel.pivot;
  const { drillFrameworks, drillCategories, statuses, search, page, pageSize } =
    panel;
  const reportingPeriod = resolveSelectedReportingPeriod(
    years,
    dashboardFiltersStore.available.reportingYears,
  );

  panel.setLoading(true);
  try {
    const data = await dashboardService.getConsolidatedOrgDetail({
      years,
      ...(reportingPeriod || {}),
      frameworks,
      categories,
      ...buildDashboardScopePayload({
        filters: dashboardFiltersStore.filters,
        orgTree: dashboardFiltersStore.available.orgTree,
      }),
      orgId,
      drillFrameworks,
      drillCategories,
      statuses,
      search,
      page,
      pageSize,
    });
    runInAction(() => {
      if (store.isExpanded(key)) {
        panel.setResult(data);
      }
    });
  } finally {
    panel.setLoading(false);
  }
};

export const loadAllConsolidatedOrgDetails = async () => {
  const store = dashboardConsolidatedOrgDetailStore;
  const keys = Array.from(store.expandedKeys);
  await Promise.all(keys.map((key) => loadConsolidatedOrgDetailForPanel(key)));
};
